/**
 * 전체 화면 로딩 (로그인 확인, 마이 페이지 정보 불러오기). public/index.html 의 boot-splash 와 같은 모양이라 이어서 보인다
 */
export function PageLoading() {
    return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-5 bg-[#f5f5f7]" role="status" aria-label="불러오는 중">
            <div className="flex flex-col items-center gap-5">
                <div className="flex items-center gap-2">
                    <img src="/assets/images/shooluk_logo.png" alt="" className="h-10 w-10 rounded-full" />
                    <span className="text-[22px] font-extrabold tracking-tight text-gray-900">shool<span className="text-[var(--mainColor)]">.</span>uk</span>
                </div>
                <span className="h-6 w-6 animate-spin rounded-full border-[3px] border-gray-200 border-t-gray-900" aria-hidden="true" />
            </div>
        </div>
    );
}

/** 전체 화면 오류 (페이지 정보를 못 불러왔을 때) */
export function PageError({ onRetry }) {
    return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-[#f5f5f7] px-4 text-center" role="alert">
            <img src="/assets/images/shooluk_logo.png" alt="" className="h-10 w-10 rounded-full" />
            <p className="text-[15px] font-bold text-gray-900">정보를 불러오지 못했어요</p>
            <p className="text-[13px] text-gray-500">잠시 후 다시 시도해 주세요.</p>
            <button type="button" onClick={onRetry} className="mt-1 rounded-lg bg-gray-900 px-4 py-2 text-[13px] font-bold text-white hover:bg-gray-700">다시 시도</button>
        </div>
    );
}
